import {appShellAppBuilder} from './config/app-builder'

import {appShellLayoutRoute} from './routes/app-shell-layout-route'
import {AppShellLayout} from './routes/AppShellLayout'

export const appShellApp = appShellAppBuilder.createDataRouterAppFromRoutes([
  appShellLayoutRoute.toRoute({Component: AppShellLayout}),
])
